import {EditProjectTeamValidationSchema} from '@/features/projects/formSchemas'
import {zodResolver} from '@hookform/resolvers/zod'
import {ReactNode} from 'react'
import {FormProvider, useForm} from 'react-hook-form'

interface EditProjectTeamFormProviderProps {
    defaultValues: EditProjectTeamValidationSchema
    children: ReactNode
}

export const EditProjectTeamFormProvider = ({defaultValues, children}: EditProjectTeamFormProviderProps) => {
    const form = useForm<EditProjectTeamValidationSchema>({
        mode: 'onBlur',
        resolver: zodResolver(EditProjectTeamValidationSchema),
        defaultValues
    })

    return <FormProvider {...form}>{children}</FormProvider>
}
